<template>
    <div>
        <a class="btn-annotation"
           href="#"
           :style="data.styleRect"
           v-show="isShowAnnot(props.annot.t)"
           @click.prevent="goToPage"
        >
            <img v-if="props.annot.icon" :src="`${bookInfoState.publicPath}/${props.annot.icon}`">
        </a>
    </div>
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed}  from "vue";
    import cssvar from '@/scss/_variables.scss';
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {usePaging} from "@/modules/reader/book/paging";
    import {useDataLoader} from "@/modules/reader/book/dataLoader";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {useAnnotationHelper} from "@/modules/reader/annotations/annotationHelper";

    const colorRect = cssvar.colorRect;
    const {pageResizeState} = usePageResize();
    const {getResizedAnnotationPos, styleAnnotationBtn, isShowAnnot} = useAnnotationHelper();
    const {bookData} = useDataLoader();

    export default {
        props: {
            annot:Object
        },
        setup(props, context) {

            const { bookData } = useDataLoader();
            const { bookInfoState} = useBookInfo();
            const { setCurrentPage} = usePaging();

            const data = reactive({
                styleRect:computed(()=>{
                    let domPos = props.annot.domPos;
                    return {
                        ...getResizedAnnotationPos(domPos),
                        ...styleAnnotationBtn(),
                        background: colorRect,
                    }
                })
            });

            //TODO: generalize in  pagestate
            const getPageIndex = (pagename)=> {
                return bookData.pagenames.indexOf(String(pagename));
            }

            const test = ()=> {
                console.log("props.annot.page:");
                console.log(props.annot)
            }

            const goToPage = () => {

                if (props.annot.isPageMark) {
                    let pageIndex =  bookData.pagenames.indexOf(String(props.annot.page));
                    setCurrentPage(pageIndex);
                } else {
                    setCurrentPage(props.annot.page - 1);
                }

            }

            onMounted(() => {
                console.log("icon: " + props.annot.icon)
            });

            return {
                data,
                props,
                bookInfoState,
                setCurrentPage,
                getResizedAnnotationPos,
                isShowAnnot,
                goToPage,
                getPageIndex,
                test
            }

        }
    }

 </script>


<style scoped lang="scss">

    img {
        width:100%;
    }

</style>